import { createFileRoute } from '@tanstack/react-router';
import { ProjectsListPage } from '../features/records/ProjectsListPage';

export const Route = createFileRoute('/projects/')({
  component: ProjectsListPage,
});
